import classNames from 'classnames';
import { useCallback, forwardRef } from 'react';
import { useBooleanState } from 'hooks/useBooleanState';
import { EditView } from './edit_view';
import { NormalView } from './normal_view';
const containerIsInvalidCss = "c1rktlr4";
const containerIsEditModeCss = "c1h2xf0e";
const containerCss = "c1xc4uq2";
const Container = forwardRef((props, ref) => {
  const {
    isInvalid,
    isEditMode,
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} data-container={`guest-email-${props.isInvalid ? 'invalid' : 'valid'}`} className={classNames(containerCss, {
    [containerIsInvalidCss]: isInvalid,
    [containerIsEditModeCss]: isEditMode
  }, props.className)} />;
});
export const Tag = ({
  id,
  className,
  name,
  onChange,
  onDelete,
  isValid,
  tagInputRef
}) => {
  const [isEditMode, setEditView, setNormalView] = useBooleanState(false);
  const handleDelete = useCallback(() => {
    onDelete(id);
    tagInputRef.current.focus();
  }, [onDelete, tagInputRef, id]);
  return <Container isEditMode={isEditMode} className={className} isInvalid={!isValid}>
      {isEditMode ? <EditView name={name} toggleView={setNormalView} onChange={onChange} /> : <NormalView name={name} onDelete={handleDelete} toggleView={setEditView} isInvalid={!isValid} />}
    </Container>;
};

require("./tag.wyw-in-js.css!=!../../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./tag.js");